// frontend/src/components/chat/ChatButton.jsx

import PropTypes from "prop-types";
import styles from "../../styles/ChatButton.module.css";

const API_ORIGIN =
  import.meta.env.VITE_API_ORIGIN ||
  (import.meta.env.VITE_API_URL?.startsWith("http")
    ? new URL(import.meta.env.VITE_API_URL).origin
    : window.location.origin);

const NOURREDINE_AVATAR = "/uploads/1778842173296-nono25.png";

function resolveMediaUrl(url) {
  if (!url) return "";
  if (
    url.startsWith("http://") ||
    url.startsWith("https://") ||
    url.startsWith("data:")
  ) {
    return url;
  }

  const cleanUrl = url.startsWith("/") ? url : `/${url}`;
  return `${API_ORIGIN}${cleanUrl}`;
}

export default function ChatButton({ toggleChat, isChatOpen = false }) {
  if (isChatOpen) return null;

  return (
    <div className={styles.container}>
      <div className={styles.chatButtonContainer}>
        <button
          type="button"
          onClick={toggleChat}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              toggleChat();
            }
          }}
          className={styles.chatButton}
          aria-label="Ouvrir le chat de Nourredine Debbari"
        >
          <img
            src={resolveMediaUrl(NOURREDINE_AVATAR)}
            alt="Nourredine Debbari"
            className={styles.chatIcon}
          />

          <div className={styles.tooltip}>
            Assistant IA de Nourredine Debbari
          </div>
        </button>
      </div>
    </div>
  );
}

ChatButton.propTypes = {
  toggleChat: PropTypes.func.isRequired,
  isChatOpen: PropTypes.bool,
};